export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="font-heading text-lg text-white mb-4">51吃瓜每日大赛</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              全网最新鲜的吃瓜社区，每日聚合娱乐圈、网红圈、商业圈最新爆料与黑料，吃瓜群众聚集地。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-sm text-white mb-4">热门板块</h4>
            <ul className="space-y-2">
              {[
                { label: '吃瓜现场', href: '#media' },
                { label: '今日大瓜', href: '#cards' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热度榜单', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-sm text-white mb-4">快速入口</h4>
            <ul className="space-y-2">
              {[
                { label: '投稿爆料', href: '#contact' },
                { label: '热门话题', href: '#topics' },
                { label: '最新快讯', href: '#updates' },
                { label: '吃瓜索引', href: '#index' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-sm text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 51吃瓜每日大赛 - 吃瓜群众聚集地。本站内容仅供娱乐，请理性吃瓜。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}